<template>
    <div class="w-full h-screen bg-gray-200 p-8">
        <div class="bg-white p-8 rounded-lg shadow-lg">


            <!-- This example requires Tailwind CSS v2.0+ -->
            <div>
                <div class="w-full flex items-center justify-between">
                    <h3 class="text-xl leading-6 font-bold text-gray-900">
                        Order #{{ order.id }}
                    </h3>
                    
                </div>
                
            </div>



        </div>



        <!-- This example requires Tailwind CSS v2.0+ -->
        <div class="flex flex-col mt-4">
            <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">

                  <div class="bg-red-300 p-8 rounded-lg mb-6" v-if="existing_credits && existing_credits.length > 0">

                    <div v-for="credit in existing_credits">
                      ${{ credit.amount.toFixed(2) }} crédit déjà approuvé par {{ report.resolution.by_livro ? 'Livro' : credit.created_by }} - {{ credit.reason}}
                    </div>

                      <div class="bg-red-700 text-white p-4 rounded-lg my-3" v-if="report.status === 1 && report.resolution.by_livro">
                          Livro a crédité / approuvé la requête du client après avoir vérifié les preuves et suite à notre procédure interne de vérification.
                      </div>
                      
                  </div>

                    

                    <ProblemResolutionPane
                        class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg bg-white"
                        :report="report"
                        :max="max"

                        @approve="submit('approve', $event)"
                        @reject="submit('reject', $event)"
                        
                        ></ProblemResolutionPane>
                    
                </div>
            </div>
        </div>



    </div>
</template>

<script>


import ConfirmableButton from "../../Shared/ConfirmableButton.vue";
import ProblemResolutionPane from "../../components/Components/ProblemResolutionPane.vue";

export default {
  name: "ProblemResolution",
    props: ['id', 'order', 'report', 'max', 'existing_credits'],
    components: {ProblemResolutionPane, ConfirmableButton},
    data() {
        let credits = this.report.resolution.proposed_credit;
        if (!credits || credits.length === 0) {
          credits = [{'amount': 0, 'taxable' : false}];
        }
    
        return {
          resolution: '',
          credits: credits,
          internal_comments: '',
          external_comments: '',
          
        }
    },
  
    computed: {
      total() {
        return this.credits.map(c => c.taxable ? c.amount * 1.14975 : c.amount * 1).reduce((a, b) => a+b, 0);
      },
      total_pre_tax() {
        return this.credits.reduce((s, c) => s + (c.amount * 1), 0);
      },
      
        valid() {
          return this.total_pre_tax <= this.max;
        }
    },

    methods: {
      
      reject() {
        this.submit("reject")
      },
      
      approve() {
        this.submit("approve")
      },
      
      submit(type, resolution) {
        this.$inertia.post(
            this.$route('merchant.problem.save', {id: this.id, order: this.order.id}),
            {
              type: type,
              resolution: resolution
            }
        )
      }

    }
    
}
</script>

<style scoped>

</style>
